import script from "./CustomLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomLink.vue?vue&type=script&setup=true&lang=ts"

import "./CustomLink.vue?vue&type=style&index=0&id=c4f294fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4f294fa"]])

export default __exports__